import { MChatPerguntaEnum } from 'graphql/types.generated'
import React from 'react'
import { MetaPath } from 'util/metaPath'

import { ConsultaSeguimentoAplicacaoItemModel } from './model-consultaSeguimento'
import { ConsultaSeguimentoPergunta01Field } from './perguntas/consulta-seguimento-pergunta-01/ConsultaSeguimentoPergunta01Field'
import { ConsultaSeguimentoPergunta02Field } from './perguntas/consulta-seguimento-pergunta-02/ConsultaSeguimentoPergunta02Field'
import { ConsultaSeguimentoPergunta03Field } from './perguntas/consulta-seguimento-pergunta-03/ConsultaSeguimentoPergunta03Field'
import { ConsultaSeguimentoPergunta04Field } from './perguntas/consulta-seguimento-pergunta-04/ConsultaSeguimentoPergunta04Field'
import { ConsultaSeguimentoPergunta06Field } from './perguntas/consulta-seguimento-pergunta-06/ConsultaSeguimentoPergunta06Field'
import { ConsultaSeguimentoPergunta07Field } from './perguntas/consulta-seguimento-pergunta-07/ConsultaSeguimentoPergunta07Field'
import { ConsultaSeguimentoPergunta08Field } from './perguntas/consulta-seguimento-pergunta-08/ConsultaSeguimentoPergunta08Field'
import { ConsultaSeguimentoPergunta13Field } from './perguntas/consulta-seguimento-pergunta-13/ConsultaSeguimentoPergunta13Field'
import { ConsultaSeguimentoPergunta15Field } from './perguntas/consulta-seguimento-pergunta-15/ConsultaSeguimentoPergunta15Field'
import { ConsultaSeguimentoPergunta17Field } from './perguntas/consulta-seguimento-pergunta-17/ConsultaSeguimentoPergunta17Field'
import { ConsultaSeguimentoPergunta19Field } from './perguntas/consulta-seguimento-pergunta-19/ConsultaSeguimentoPergunta19Field'

export const ConsultaSeguimentoPerguntasMap: Partial<Record<
  MChatPerguntaEnum,
  {
    Field: React.ComponentType<{
      name: MetaPath<ConsultaSeguimentoAplicacaoItemModel>
      perguntasSelecionadas: MChatPerguntaEnum[]
    }>
  }
>> = {
  PERGUNTA_01: {
    Field: ConsultaSeguimentoPergunta01Field,
  },
  PERGUNTA_02: {
    Field: ConsultaSeguimentoPergunta02Field,
  },
  PERGUNTA_03: {
    Field: ConsultaSeguimentoPergunta03Field,
  },
  PERGUNTA_04: {
    Field: ConsultaSeguimentoPergunta04Field,
  },
  PERGUNTA_05: {
    Field: () => <div />,
  },
  PERGUNTA_06: {
    Field: ConsultaSeguimentoPergunta06Field,
  },
  PERGUNTA_07: {
    Field: ConsultaSeguimentoPergunta07Field,
  },
  PERGUNTA_08: {
    Field: ConsultaSeguimentoPergunta08Field,
  },
  PERGUNTA_09: {
    Field: () => <div />,
  },
  PERGUNTA_10: {
    Field: () => <div />,
  },
  PERGUNTA_11: {
    Field: () => <div />,
  },
  PERGUNTA_12: {
    Field: () => <div />,
  },
  PERGUNTA_13: {
    Field: ConsultaSeguimentoPergunta13Field,
  },
  PERGUNTA_14: {
    Field: () => <div />,
  },
  PERGUNTA_15: {
    Field: ConsultaSeguimentoPergunta15Field,
  },
  PERGUNTA_16: {
    Field: () => <div />,
  },
  PERGUNTA_17: {
    Field: ConsultaSeguimentoPergunta17Field,
  },
  PERGUNTA_18: {
    Field: () => <div />,
  },
  PERGUNTA_19: {
    Field: ConsultaSeguimentoPergunta19Field,
  },
  PERGUNTA_20: {
    Field: () => <div />,
  },
}
